import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { deletePathwayAsync } from "../../Helpers/API/PathwayApi";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";

const PathwayTableRow = (props) => {
	const { pathway, deleteRow, showConflictNotification } = props;

	const deletePathwayOnClick = (name) => {
		async function deletePathway() {
			const { success, isConflicted, conflicts } = await deletePathwayAsync(pathway.id);
			if (success) deleteRow(pathway.id);
			if (isConflicted) showConflictNotification(conflicts);
		}

		ConfirmDialog({ entityName: name, onDelete: deletePathway });
	};

	return (
		<tr>
			<td>{pathway.name}</td>
			<td>
				<Link to={`/pathways/update-pathway/${pathway.id}`} className="update-link">
					Update
				</Link>
				<Button onClick={() => deletePathwayOnClick(pathway.name)} size="sm" variant="danger">
					Delete
				</Button>
			</td>
		</tr>
	);
};
PathwayTableRow.propTypes = {
	pathway: PropTypes.shape({
		id: PropTypes.string.isRequired,
		name: PropTypes.string.isRequired,
	}).isRequired,
	deleteRow: PropTypes.func.isRequired,
	showConflictNotification: PropTypes.func.isRequired,
};

export default PathwayTableRow;
